import { isRequired } from '@/util/formValidators';
import { ErrorMessage } from '@hookform/error-message';
import { useRouter } from 'next/navigation';
import { useForm } from 'react-hook-form';

const TrackOrderForm = () => {
  const router = useRouter();
  const { register, handleSubmit, formState } = useForm({
    defaultValues: {
      email: '',
      orderNumber: '',
    },
  });

  return (
    <form
      className='mt-5'
      onSubmit={handleSubmit(({ email, orderNumber }) => {
        router.push(`/orderstatus?email=${email}&ordernumber=${orderNumber}`);
      })}
    >
      <div>
        <div className='font-roboto-regular text-base leading-6'>
          <span className='text-e82f2f'>*</span>
          <span className='ml-0.5'>Order Number</span>
        </div>
      </div>
      <input
        {...register('orderNumber', {
          validate: isRequired,
        })}
        className='mt-[5px] h-[50px] w-full rounded-[3px] border-1 border-solid border-e0e0e0 px-5 font-roboto-light text-base outline-0'
      />
      <div className='relative'>
        <div className='absolute left-0 top-0 font-roboto-regular text-xs text-e82f2f'>
          <ErrorMessage
            errors={formState.errors}
            name='orderNumber'
          ></ErrorMessage>
        </div>
      </div>

      <div className='mt-5'>
        <div className='font-roboto-regular text-base leading-6'>
          <span className='text-e82f2f'>*</span>
          <span className='ml-0.5'>Billing Zip Code or Email</span>
        </div>
      </div>
      <input
        {...register('email', {
          validate: isRequired,
        })}
        className='mt-[5px] h-[50px] w-full rounded-[3px] border-1 border-solid border-e0e0e0 px-5 font-roboto-light text-base outline-0'
      />
      <div className='relative'>
        <div className='absolute left-0 top-0 font-roboto-regular text-xs text-e82f2f'>
          <ErrorMessage
            errors={formState.errors}
            name='email'
          ></ErrorMessage>
        </div>
      </div>

      <button
        priority='high'
        className='mt-5 flex h-10 w-full items-center justify-center rounded-[102px] bg-black font-roboto-medium text-base text-white lg_h-[50px] lg_w-auto lg_px-11 lg_text-lg lg_enabled_hover_bg-4c4c4c'
        type='submit'
      >
        Track Order
      </button>
    </form>
  );
};

export default TrackOrderForm;
